/**
 * Parsovanie GET /api/{resource}/{id} pre deep linky (UtilContext / deepLinkHandlers).
 * @param {unknown} res
 * @returns {object|null}
 */
export function parseEntityShowResponse(res) {
  if (!res) return null;
  if (Number(res.status) === 404 || Number(res.status) >= 400) return null;
  const record = res?.data?.data ?? res?.data ?? (res?.id != null ? res : null);
  return record?.id != null ? record : null;
}
